export enum ModalSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
